<div [formGroup]="group">
    <ng-container *ngIf="config.context === 'hotel'">
        <h2 class="form-title">{{ Yii.t('wui-shared-js', 'Date de séjour') }}</h2>
        <div *ngFor="let segment of group.controls; let i = index" class="htl fieldset" [formGroupName]="i">
            <div class="segment">
                <div class="col-to-row-l-mb">
                    <date-field class="field-sep night-ctn "
                                [fieldConfig]="{formGroup: segment,
                                     formControlName: 'begin',
                                     minDate:today,
                                     disabled:config.disableDates,
                                     validators: dateValidator,
                                     placeholder: Yii.t('wui-shared-js', 'Arrivée') }"
                    (onSelect)="setDateAndNightFromBegin(i)"
                    (onBlur)="setDateAndNightFromBegin(i)"></date-field>
<!--                    <date2months-field-->
<!--                            [error]="{ message: 'Le champ date est requis', condition: segment.get(['begin']).touched && segment.get(['begin']).hasError('required') }"-->
<!--                            class="field-sep"-->
<!--                            [placeholder]=""-->
<!--                            [group]="" controlName=""-->
<!--                            icon="fa fa-calendar"-->
<!--                            [minDate]=""-->
<!--                            [disabled]="config.disableDates"-->
<!--                            (selectDate)="setDateAndNightFromBegin(i)"-->
<!--                            (blur)="setDateAndNightFromBegin(i)"></date2months-field>-->
                    <number class="field-sep night-ctn fix-width-1"
                            [labelPosition]="labelPosition"
                            [fieldConfig]="{
                                formGroup: segment.controls.duration,
                                formControlName: 'night',
                                label: wording.nights,
                                disabled: config.disableDates,
                                fixed: 0
                            }"
                    (onChange)="setEndDateFromNumber(i)"></number>
                    <!--                    <number-field-->
                    <!--                            [error]="{ message: 'Le champ date est requis', condition: segment.get(['duration', 'night']).touched && segment.get(['duration', 'night']).hasError('required') }"-->
                    <!--                            [group]="segment.controls.duration"-->
                    <!--                            class="field-sep night-ctn fix-width-1" styleForm="night"-->
                    <!--                            label="Nuits" controlName="night"-->
                    <!--                            [disabled]="config.disableDates"-->
                    <!--                            (click)="setEndDateFromNumber(i)"-->
                    <!--                            (keyUp)="setEndDateFromNumber(i)"></number-field>-->
                    <date-field class="field-sep night-ctn "
                                [fieldConfig]="{formGroup: segment,
                                     formControlName: 'end',
                                     minDate:getLastDate(1),
                                     disabled:config.disableDates,
                                     validators: dateValidator,
                                     placeholder: Yii.t('wui-shared-js', 'Départ') }"
                                (onSelect)="setNumberFromBeginEndDate(i)"
                                (onBlur)="setNumberFromBeginEndDate(i)"></date-field>

<!--                    <date2months-field-->
<!--                            [error]="{ message: 'Le champ date est requis', condition: segment.get(['end']).touched && segment.get(['end']).hasError('required') }"-->
<!--                            class="field-sep"-->
<!--                            [placeholder]="Yii.t('wui-shared-js', 'Départ')"-->
<!--                            [group]="segment" controlName="end"-->
<!--                            icon="fa fa-calendar"-->
<!--                            [minDate]="getLastDate(1)"-->
<!--                            [disabled]="config.disableDates"-->
<!--                            (selectDate)="setNumberFromBeginEndDate(i)"-->
<!--                            (blur)="setNumberFromBeginEndDate(i)"></date2months-field>-->
                </div>


            </div>

        </div>
    </ng-container>

</div>
